import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import * as z from 'zod/v4';

export const Route = createFileRoute('/login')({
  validateSearch: zodValidator(
    z.object({
      errorMessage: z.string().optional(),
    }),
  ),
});
